/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaginationComponent implements OnInit {

    @Input() collectionSize: number;
    @Input() pageSize: number;
    @Input() page = 1;
    @Output() pageNumber = new EventEmitter<number>();

    constructor() {
    }

    ngOnInit(): void {
    }

    outputPageNumber(page: number): void {
        this.page = page;
        this.pageNumber.emit(page);
    }

}
